module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td colspan="5">\n    <p>'+
((__t=( t('settings::trash:note:empty-trash') ))==null?'':_.escape(__t))+
'</p>\n</td>';
}
return __p;
};